
import { Control } from "react-hook-form";
import { 
  FormField, 
  FormItem, 
  FormLabel, 
  FormControl, 
  FormMessage 
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { ClientFormValues } from "../form-utils/clientFormUtils";

interface GoalsNotesFormProps {
  control: Control<ClientFormValues>;
}

export function GoalsNotesForm({ control }: GoalsNotesFormProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <FormField
        control={control}
        name="goals"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-medium">Goals (Optional)</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Client's fitness goals..."
                className="bg-black/20 border-black/20 text-white h-32 placeholder:text-white/60 focus:border-white/40 focus:ring-white/10"
                {...field}
              />
            </FormControl>
            <FormMessage className="text-red-300" />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-white font-medium">Additional Notes (Optional)</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Any additional information..."
                className="bg-black/20 border-black/20 text-white h-32 placeholder:text-white/60 focus:border-white/40 focus:ring-white/10"
                {...field}
              />
            </FormControl>
            <FormMessage className="text-red-300" />
          </FormItem>
        )}
      />
    </div>
  );
}
